import { motion } from "framer-motion";
import { BRAND } from "@/branding.config";

/**
 * Section-level reveal wrapper — fades + rises on scroll into view.
 * Use around any block to add a premium entrance animation.
 */
export default function Reveal({ children, delay = 0, y = 24, className = "", once = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
